import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Map from './Map';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import header from './Header';
import Paper from '@material-ui/core/Paper';
import Input from './TextBox';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 3),
    backgroundColor: 'rgb(51,51,51)',
    margin: '3px',
  },
  bodyStyle: {
    padding: (20),
    backgroundColor: 'rgb(34,34,34)',
  },
  fontHeader: {
    fontSize: '50px',
  },
  imageContainer: {
    padding: theme.spacing(1, 1),
    backgroundColor: 'rgb(51,51,51)',
    margin: '1px',
  }
}));
/*
<Input
      id={1}
      label="Field label"
      locked={false}
      active={false}></Input>
*/
export default function PaperSheet() {
  const classes = useStyles();

  return (
    <div className={classes.bodyStyle}>ß
      
      <header></header>
      
      
       
      <Paper className={classes.root}>
     <Map></Map>
      </Paper>
    </div>
  );
}

